module.exports = __webpack_public_path__ + "img/danone.bb3696ae.png";